export const getClientInvoicingAmountColumn = (soStatus) => (
  String(soStatus || "").trim().toLowerCase() === "ready_to_invoice"
    ? { field: "uninvoicedAmount", headerName: "Remaining to Invoice" }
    : { field: "remainingAmount", headerName: "Remaining Amount" }
);
